import React, {useEffect, useState} from "react";
import './ActivateWatch.css'
import Header from "../../../components/header/Header";
import Indicator from "../../common/components/Indicator";
import {Button, Divider, Form, message, Modal} from "antd";
import ModalContent from "../../../constant/ModalContent";
import {useNavigate} from "react-router-dom";
import {activateWatch} from "../services/FamilyPlan.service";
import {CloseCircleFilled} from "@ant-design/icons";

export default function ActivateWatch() {


    const [isLoading, setIsLoading] = useState(false);
    const searchParams = new URLSearchParams(window.location.search);
    const carrierPostData = window.location.search.match(/(?<=\?|&)carrierPostData=([^&]*)/)?.[1] ?? null;

    const navigate = useNavigate();
    const watchNumber = localStorage.getItem('watchNo')

    const [modalContent, setModalContent] = useState("");
    const [visible, setVisible] = useState(false);

    const sessionId = localStorage.getItem('sessionId')

    useEffect(()=>{
        if (!sessionId){
            // Redirect to NotFoundPage if any data is null
            navigate('/not-found-page');
        }
    },[])


    const handleSubmit = async (values) => {
        setIsLoading(true);

        try {

            const payload = {
                "request-id": Date.now().toString() + Math.floor(1000 + Math.random() * 9000),
                "carrierPostData" : carrierPostData,
                "serviceType" : "TREMBLANT"
            }

            const response = await activateWatch(payload);

            setIsLoading(false);

            if (response.resultCode === 6000) {

                const {eid,iccid}=response;
                console.log(eid);
                console.log(iccid);

                navigate("/proceed/family-plan-congrats", {state: {eid:eid,iccid:iccid}});


            } else {

                setModalContent(
                    <>
                        <CloseCircleFilled/>
                        <h3>Error Occurred</h3>
                        <div>
                            {response.resultDesc}
                        </div>
                        <Divider/>
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Invalid ID number").replace("{{page}}", LogContent.LOGIN_PAGE));
                // isMountedRef.current = false;
            }


        } catch (error) {
            setIsLoading(false);
            message.error(ModalContent.GENERAL_ERROR_DESCRIPTION, 1);
            throw new Error(error);
        }
    }


    const handleCancelWithCallback = () => {
        // eslint-disable-next-line no-undef
        DataActivationController.doneSelected()
        setVisible(false);
        // setLogMessage(LogContent.LOGIN_PAGE_MESSAGE);
        // isMountedRef.current = false;
    };


    const handleCancel = () => {
        setVisible(false);
        // setLogMessage(LogContent.LOGIN_PAGE_MESSAGE);
        // isMountedRef.current = false;
    };



    return (
        <div>
            <div style={{backgroundColor: "#E6E6E6", width: "100%"}}>
                <Header/>
            </div>

            {isLoading && <Indicator/>}


            {watchNumber &&
                (
                    <Form
                        className="form"
                        name="form"
                        onFinish={handleSubmit}
                    >
                        <h1 className="para-title">
                            Thank you! Now, let's activate your watch.
                        </h1>

                        <div className='para-sub-title'>
                            Tap below to continue setting up your Apple Watch
                        </div>

                        <div className='element'>
                            <div className='element-name'>
                                YOUR WATCH'S NUMBER
                            </div>
                            <div className='element-value'>
                                {watchNumber}
                            </div>
                        </div>



                        <Form.Item>
                            <Button
                                className="mainButton agreeButton"
                                type="primary"
                                htmlType="submit"
                                shape={"round"}
                                style={{backgroundColor: "#f13434",marginRight: 10}}
                                // disabled={isLoading}
                            >
                                Activate
                            </Button>
                        </Form.Item>
                    </Form>
                )
            }

            <Modal
                open={visible}
                onCancel={handleCancel}
                footer={null}
                closable={false}
            >
                {modalContent}
            </Modal>

        </div>
    );
}